<script>
import { getCommunity } from '../api/community';
import { getPersonalData } from '../api/feed';

export default {
  name: 'CpCommunitySection',
  components: {
    CpBox: require('../box').default,
    VueSimpleSpinner: require('../vue-simple-spinner').default,
    InfiniteLoading: require('vue-infinite-loading').default,
    CpSearchResult: require('../explore-campaigns/result').default,
    CpSocialFeedVideoPost: require('./posts/video-post').default,
    CpSocialFeedLivestreamPost: require('./posts/livestream-post').default,
    CpSocialFeedPetitionPost: require('./posts/petition-post').default,
    CpSocialFeedRacePost: require('./posts/race-post').default,
    CpSocialFeedCandidatePost: require('./posts/candidate-post').default,
    CpSocialFeedBlogPost: require('./posts/blog-post').default,
    CpSocialFeedNewsPost: require('./posts/news-post').default,
    CpMembers: require('./members').default,
    CpOpinionsItem: require('../opinions/opinions-item').default,
    CpSharePostItem: require('.//posts/share-post-item').default,
    CpSocialFeedNewMemberPost: require('./posts/new-member-post').default,
    CpSocialFeedCustomContent: require('./posts/CustomContent').default,
    CpSocialFeedPollPost: require('./posts/poll-post').default,
    CpEventCard: require('../events/event-card.vue').default,
    CpGroups: require('../groups/groups').default,
    CpGroup: require('../groups/group-card').default,
    CpSocialFeedLobbyPost: require('./posts/lobby-post').default,
    CpOpinionsContainer: require('../opinions/opinions-container').default,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginLeft: require('../directives/margins').marginLeft,
    marginRight: require('../directives/margins').marginRight,
    marginBottom: require('../directives/margins').marginBottom,
  },
  props: {
    currentUser: { type: Object },
    placeholderStatusPost: { type: String },
    resultsUrlSuffix: { type: String },
    showInviteDialog: { type: Boolean },
  },
  data: () => ({
    communityData: [],
    page: 0,
  }),
  methods: {
    combineCommunityItems(currItems, newItems) {
      const items = [...currItems];

      for (const newItem of newItems) {
        const index = items.findIndex(post => post.data.id == newItem.data.id && post.feed_item_type == newItem.feed_item_type);

        if (index > -1) {
          items[index].data = { ...items[index].data, ...newItem.data };
        } else {
          items.push(newItem);
        }
      }

      return items;
    },
    fetchCommunity($state) {
      getCommunity({ page: this.page })
        .then(async response => {
          if (response.feed_items.length) {
            const { feed_items } = response;

            const postsIdsWithoutDuplicates = feed_items
              .map(post => [post.data.id, post.feed_item_type])
              .filter(([id, feed_item_type]) => this.communityData.findIndex(item => item.data.id == id && item.feed_item_type == feed_item_type) == -1);

            await getPersonalData({ posts: postsIdsWithoutDuplicates })
              .then(response => {
                const { personal_data } = response;

                for (const personal of personal_data) {
                  const { id, feed_item_type, ...rest } = personal;
                  const comm = feed_items.find(post => post.data.id == id && post.feed_item_type == feed_item_type);

                  if (comm) {
                    comm.data = {
                      ...comm.data,
                      ...rest,
                    };
                  }
                }
              })
              .catch(error => {
                console.warn(error);
              });

            this.communityData = this.combineCommunityItems(this.communityData, feed_items);
            this.page += 1;

            $state.loaded();
          } else {
            $state.complete();
          }
        })
        .catch(error => {
          $state.complete();
          console.warn(error);
        });
    },
    updateFeed() {
      window.scrollTo({
        top: 350,
        left: 0,
        behavior: 'smooth',
      });
      this.emptyFeed();
    },
    emptyFeed() {
      this.page = 0;
      this.communityData = [];
    },
  },
};
</script>
<template>
  <cp-box>
    <CpOpinionsContainer
      :current-user="currentUser"
      :name="currentUser != null ? currentUser.first_name : ''"
      :placeholder-status-post="placeholderStatusPost"
      :reload="updateFeed"
    />
    <transition-group name="feed-fade">
      <div v-for="(comm, index) in communityData" :key="comm.feed_item_type.toString() + '-' + index.toString()">
        <CpSearchResult
          v-if="comm.feed_item_type == 'campaign'"
          style="margin-bottom: 2.5em"
          :result="comm.data"
          :explore="true"
          :feed="true"
          :current-user="currentUser"
          :modal="showInviteDialog"
          :results-url-suffix="resultsUrlSuffix"
        ></CpSearchResult>
        <CpSocialFeedCustomContent v-if="comm.feed_item_type == 'custom_content'" :post="comm.data" :explore="true" />
        <CpOpinionsItem v-if="comm.feed_item_type == 'opinion'" :data="comm.data" :explore="true" :type="'opinion'" />
        <CpSocialFeedBlogPost v-if="comm.feed_item_type == 'blog'" :key="comm.id" :blog="comm.data" :explore="true" />
        <CpSocialFeedCandidatePost
          v-if="comm.feed_item_type == 'candidate'"
          :key="comm.id"
          :candidate="comm.data"
          :for-share="false"
          :explore="true"
          :modal="showInviteDialog"
          :iconState="true"
        />
        <CpSocialFeedNewsPost v-if="comm.feed_item_type == 'news'" :key="comm.rss_article_url" :news="comm.data" :explore="true" />
        <CpSharePostItem v-if="comm.feed_item_type == 'post_shared'" :post-shared="comm.data" :results-url-suffix="resultsUrlSuffix" />
        <CpSocialFeedPetitionPost v-if="comm.feed_item_type == 'petition'" :key="comm.id" :petition="comm.data" :explore="true" :user="currentUser" />
        <CpSocialFeedRacePost v-if="comm.feed_item_type == 'election'" :race="comm.data" :explore="true" />
        <CpSocialFeedNewMemberPost v-if="comm.feed_item_type == 'new_member'" :newMember="comm.data" :user="currentUser" />
        <CpSocialFeedLobbyPost
          v-if="comm.feed_item_type == 'lobby'"
          :key="comm.id"
          :lobby="comm.data"
          :for-share="false"
          :explore="true"
          :iconState="true"
          :user="currentUser"
        />
        <CpSocialFeedPollPost
          v-if="comm.feed_item_type == 'poll'"
          :key="comm.id"
          :poll="comm.data"
          :for-share="false"
          :explore="true"
          :iconState="true"
          :user="currentUser"
        />
        <div v-if="comm.feed_item_type == 'event'">
          <CpSocialFeedLivestreamPost
            v-if="comm.data.archive_url && comm.data.status == 'shared'"
            :key="comm.id"
            :playback="comm.data.archive_url"
            :title="comm.data.title"
            :type="'event'"
            :data="comm.data"
          />
          <CpEventCard v-else :key="comm.id" :event="comm.data" />
        </div>

        <CpGroup
          v-if="comm.feed_item_type == 'group'"
          v-margin-bottom="2"
          :key="comm.id"
          :group="comm.data"
          :current-user="currentUser"
          :type="comm.data.type"
        />

        <CpOpinionsItem v-if="comm.feed_item_type == 'group_opinion'" :data="comm.data" :explore="true" :type="'group-opinions'" />

        <CpSocialFeedLivestreamPost
          v-if="comm.feed_item_type == 'livestream'"
          :key="comm.id"
          :playback="comm.data.archive_url"
          :title="comm.data.title"
          :type="comm.data.type"
          :data="comm.data"
        />
      </div>
    </transition-group>
    <transition name="feed-fade" mode="out-in">
      <InfiniteLoading @infinite="fetchCommunity" v-margin="1" key="scrolling">
        <div slot="spinner">
          <div class="heading-4"><vue-simple-spinner v-margin="1" /> Loading Community...</div>
        </div>
        <div slot="no-more">
          <div class="heading-4">That's all!</div>
        </div>
        <div slot="no-results">
          <div class="heading-4">That's all!</div>
        </div>
      </InfiniteLoading>
    </transition>
  </cp-box>
</template>

<style scoped></style>
